import React from 'react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ServerDashboardJob } from '../../dashboardType';
import { formatDuration } from './durationUtils';
import { useLiveDuration } from './useLiveDuration';

const DurationCell = (
  properties: CustomCellRendererProps<ServerDashboardJob>
) => {
  const startTime = properties.data?.startTime;
  const endTime = properties.data?.endTime;

  const currentTime = useLiveDuration(startTime, endTime);

  const hasNoData = !properties.data;
  if (hasNoData) {
    return null;
  }

  const hasNoStartTime = !startTime;
  if (hasNoStartTime) {
    return null;
  }

  const formattedDuration = formatDuration(startTime, endTime, currentTime);

  return <span>{formattedDuration}</span>;
};

export default DurationCell;
